export default {
    diesel: 'Diesel',
    electric: 'Électrique',
    gasoline: 'Essence',
    hybrid: 'Hybride',
};
